export default {
	documents: {
		previewError: {
			line1: 'Leider konnte keine Vorschau angezeigt werden.',
			line2: 'Bitte öffnen oder speichern Sie das Dokument!',
		},
		relatedFiles: 'Dateien zu dem Dokument',
		noFilesInContainer:
			'Es wurden noch keine Dateien in den Dokumentcontainern gefunden.',
		noFilesMatchSearch: 'Keine Dateien entsprechen Ihrer Suche',
		downloadAll: 'Alle herunterladen',
		download: 'Herunterladen',
		selectAll: '@:common.selectAll',
		deselectAll: 'Alle auswählen',
		clearSelection: 'Auswahl aufheben',
		selectedBar: '{count} Datei ausgewählt | {count} Dateien ausgewählt',
		attachments: 'Anhänge',
		searchPlaceholder: 'Dateien durchsuchen...',
		sortBy: 'Sortieren nach',
		perPage: 'Pro Seite',
		showing: 'Zeige',
		of: 'von',
		groups: 'Gruppen',
		folders: 'Ordner',
		files: 'Dateien',
		noFolder: 'Ohne Ordner',
		noDocumentType: 'Kein Dokumenttyp',
		selectedOf: '{count} von {total} Dateien gewählt',
		downloadZip: '{count} Datei laden (ZIP) | {count} Dateien laden (ZIP)',
		downloadFolder: 'Ordner laden (ZIP)',
		hiddenNoMatch:
			'{count} Datei ohne Treffer ausgeblendet | {count} Dateien ohne Treffer ausgeblendet',
		showAll: 'alle anzeigen',
		noMatch: 'kein Treffer',
		matchCount: '{count} Treffer',
		journalCount: '{count} Buchung | {count} Buchungen',
		toJournal: 'Zur Buchung',
		fileAndDocument: 'Datei · Dokument',
		fileHandling: {
			removeFile: 'Datei entfernen',
			containerName: 'Bezeichnung',
			fileName: 'Dateiname',
			addFiles: 'Dateien hinzufügen',
			addContainer: 'Weiteres Dokument',
			removeContainer: 'Dokument entfernen',
			willBeDeleted: 'wird gelöscht',
			willBeDetached: 'wird entknüpft',
		},
		containerDialog: {
			documentCount: 'Dokumente',
			newDocument: 'Neues Dokument anlegen',
			unnamedDocument: 'Ohne Bezeichnung',
			dropNew: 'Dateien hier ablegen → neues Dokument',
			dropMore: 'Weitere Dateien in dieses Dokument ablegen oder',
			splitFiles: 'Jede Datei als eigenes Dokument',
			chooseFiles: 'wählen',
			typeForAll: 'Art für alle Dateien',
			typeForAllSet:
				'Dokumentart „{type}" für alle Dateien dieses Dokuments gesetzt',
			moreActions: 'Weitere Aktionen',
			detach: 'Entknüpfen',
			detachHint:
				'Entfernt das Dokument nur hier — es bleibt in {target} erhalten',
			detachHintGeneric:
				'Entfernt das Dokument nur hier — es bleibt anderswo erhalten',
			delete: 'Löschen',
			deleteHint: 'Löscht das Dokument mit allen Dateien überall',
			discard: 'Verwerfen',
			discardHint: 'Das neue Dokument wieder entfernen',
			undoMark: 'Markierung aufheben',
			markedForDetach:
				'Wird beim Speichern entknüpft — bleibt in {target} erhalten.',
			markedForDetachGeneric:
				'Wird beim Speichern entknüpft — bleibt anderswo erhalten.',
			markedForDelete:
				'Wird beim Speichern gelöscht — mit allen Dateien, überall.',
			fileMarkedForDelete: 'wird beim Speichern gelöscht',
			isNew: 'neu',
			suggestion: 'Vorschlag — wird beim Speichern übernommen',
			missingType: 'Dokumentart fehlt',
			missingTypeCount:
				'{count} Dokumentart fehlt | {count} Dokumentarten fehlen',
			fileCount: '{count} Datei | {count} Dateien',
			countNew: 'neu',
			countDelete: 'löschen',
			countDetach: 'entknüpfen',
			countChanged: 'geändert',
			saveChanges: '{count} Änderung speichern | {count} Änderungen speichern',
			noDocuments:
				'Noch kein Dokument — links über das Plus eines anlegen oder Dateien ablegen.',
			noDocumentsReadonly: 'Zu dieser Prüfung sind keine Anlagen hinterlegt.',
			documentPosition: 'Anlagen · Dokument {index} von {total}',
			renameFile: 'Zum Umbenennen klicken',
			deleteFile: 'Beim Speichern löschen',
			removeFile: 'Datei entfernen',
			undoDelete: 'Löschen rückgängig',
			openPreview: 'Vorschau öffnen',
			viewMode: 'Anlagen ansehen',
			manageMode: 'Anlagen pflegen',
			unsavedInView:
				'Sie haben ungespeicherte Änderungen. Die Ansicht zeigt den gespeicherten Stand — zum Speichern zurück in die Pflege wechseln.',
			previewUnavailable: 'Die Vorschau steht erst nach dem Speichern bereit.',
			modeManage: 'Pflege',
			modeView: 'Ansicht',
			noChanges: 'Keine offenen Änderungen',
			filesSection: 'Dateien',
			filesWithTypeAll: 'alle mit Dokumentenart',
			filesWithType: '{done} / {total} mit Art',
			missingTypeShort: '{count} ohne Art',
			missingName: 'Bezeichnung fehlt',
			missingNameCount:
				'Bezeichnung fehlt bei {count} Dokument | Bezeichnung fehlt bei {count} Dokumenten',
			journalCount: '{count} Buchung | {count} Buchungen',
			noJournal: 'keine Buchung',
			fileCountChange: '{from} → {to} Dateien',
			filesMarkedForDelete:
				'{count} Datei wird gelöscht | {count} Dateien werden gelöscht',
			typeForAllApplied:
				'Auf {count} Datei übernommen | Auf {count} Dateien übernommen',
			summary:
				'{docs} Dokumente · {files} Dateien · {assigned} einer Buchung zugeordnet',
		},
		dropzone: {
			title: 'Dateien hier ablegen zum Hochladen',
			hint: 'Erlaubt: {types} — max. {maxSize} MB pro Datei',
		},
		view: {
			list: 'Listenansicht',
			container: 'Ordneransicht',
			grouped: 'Dokumentenarten',
		},
		tooltip: {
			list: 'Listenansicht',
			container: 'Ordneransicht',
			grouped: 'Dokumentenartansicht',
		},
		filter: {
			type: 'Dokumentart',
			reset: 'Zurücksetzen',
			count: '{count} von {total} Dateien',
		},
		column: {
			file: 'Datei',
			type: 'Dokumentart',
			folder: 'Ordner',
			size: 'Größe',
			date: 'Datum',
		},
		sort: {
			typeAsc: 'Dokumenttyp: A-Z',
			typeDesc: 'Dokumenttyp: Z-A',
			createdDesc: 'Neueste zuerst',
			createdAsc: 'Älteste zuerst',
			nameAsc: 'Name: A-Z',
			nameDesc: 'Name: Z-A',
		},
	},
}
